import { Component, signal, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';
import { RoleService } from '../auth/role-service';
import { Role } from 'shared-lib';
import { environment } from '../../environments/environment';

interface HomeLink {
  id: string;
  title: string;
  description: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-home',
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, RouterLink, TranslatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  private readonly keycloak = inject(Keycloak);
  private readonly roleService = inject(RoleService);

  homeLinks = signal<HomeLink[]>([]);
  protected readonly environment = environment;

  constructor() {
    if (!this.keycloak.authenticated) {
      this.keycloak.login();
    }
  }

  async ngOnInit(): Promise<void> {
    await this.initializeLinks();
  }

  private async initializeLinks(): Promise<void> {
    const links: HomeLink[] = [];

    const isOrgMember = (await this.roleService.checkAccess(Role.OrganizationMember)) ||
      (await this.roleService.checkAccess(Role.OrganizationAdmin)) ||
      (await this.roleService.checkAccess(Role.Administrator));

    if (isOrgMember) {
      links.push({
        id: 'pools',
        title: 'nav.pools',
        description: 'home.poolsDescription',
        icon: 'local_parking',
        route: '/pools'
      });
      links.push({
        id: 'my-account',
        title: 'nav.myAccount',
        description: 'home.myAccountDescription',
        icon: 'account_circle',
        route: '/my-account'
      });
    }

    this.homeLinks.set(links);
  }
}
